import { render, staticRenderFns } from "./Resourcesfigure.vue?vue&type=template&id=fc283a3a&scoped=true&"
import script from "./Resourcesfigure.vue?vue&type=script&lang=js&"
export * from "./Resourcesfigure.vue?vue&type=script&lang=js&"
import style0 from "./Resourcesfigure.vue?vue&type=style&index=0&id=fc283a3a&scoped=true&lang=css&"
import style1 from "./Resourcesfigure.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc283a3a",
  null
  
)

export default component.exports